import Core from '@mediaplatform/sportal365-football-sdk-v2';
import { useMemo } from 'react';
import { competition, football, lineups, mostDecorated, player, seasons, stage, stageList, team, teamSquad, topScorers } from '../api';
import initSmpFootballSDK from '../lib/SmpFootballSDK';

import { FootballSDKOptions as footballOptions, IUseFootballApi } from '../types';
import { timeline } from '../api/timeline';

export const getFootballApi = (sdkFootball: Core): IUseFootballApi => {
  return {
    $football: football(sdkFootball),
    $competition: competition(sdkFootball),
    $stageList: stageList(sdkFootball),
    $stage: stage(sdkFootball),
    $player: player(sdkFootball),
    $team: team(sdkFootball),
    $teamSquad: teamSquad(sdkFootball),
    $seasons: seasons(sdkFootball),
    $topScorers: topScorers(sdkFootball),
    $mostDecorated: mostDecorated(sdkFootball),
    $lineups: lineups(sdkFootball),
    $timeline: timeline(),
  };
};

// Plain function to use outside React components
export const initFootballApi = (sdkOptions: footballOptions): IUseFootballApi => {
  const sdkFootball = initSmpFootballSDK(sdkOptions);

  return getFootballApi(sdkFootball);
};

// React hook to use inside React components
export default function useFootballApi(sdkOptions: footballOptions): IUseFootballApi {
  const sdkFootball = useMemo(() => initSmpFootballSDK(sdkOptions), [sdkOptions]);

  return useMemo(() => getFootballApi(sdkFootball), [sdkFootball]);
}
